export const env = "prod";

const siteUrls = {
  local: process.env.REACT_APP_API_URL_LOCAL,
  dev: process.env.REACT_APP_API_URL_DEV,
  prod: process.env.REACT_APP_API_URL_PROD,
};

// export const API_URL =
//   process.env.NODE_ENV === "development" ? "/api" : siteUrls[env];
export const API_URL = siteUrls[env];
export const REACT_APP_GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
